import support from './utils/support'

let root          = document.documentElement;
// let winHeight     = window.innerHeight;
let winWidth      = document.body.clientWidth;
// let lastVH        = window.innerHeight;
let maxScreenSize = Number( getComputedStyle(root).getPropertyValue('--maxScreenSize') );
let minScreenSize = Number( getComputedStyle(root).getPropertyValue('--minScreenSize') );
let minVR         = Number( getComputedStyle(root).getPropertyValue('--vrMin') );
let maxVR         = Number( getComputedStyle(root).getPropertyValue('--vrMax') );
// let lastVW        = 0;

document.body.classList.add(support.touch ? 'has-touch' : 'has-not-touch')

let timerCheck;
export default function updateWinH() {
    root.style.setProperty('--vh', window.innerHeight + 'px');
    root.style.setProperty('--windowHeight', window.innerHeight + 'px');
    clearTimeout( timerCheck )
    timerCheck = setTimeout(()=>{
        updateWinH()
    }, 3000)
}

function onResize() {
    let bodyW =  document.body.clientWidth
    root.style.setProperty('--vw',  bodyW + 'px' );
    
    if (document.querySelector('[data-header]')) {
        root.style.setProperty('--headerHeight', document.querySelector('[data-header]').clientHeight + 'px' );
    }

    //on mobile, we dont want the adress bar to trigger reisze on scroll
    // if ( winWidth == bodyW && bodyW < 768) {
    //     return
    // }
    // if ( Math.abs(lastVH - window.innerHeight) > 75 || bodyW != lastVW) {
        // lastVH = window.innerHeight
        // root.style.setProperty('--windowHeight', window.innerHeight + 'px');
        updateWinH()
    // }

    // winHeight = window.innerHeight;
    winWidth  = bodyW;
    let VR    = (minVR + (maxVR - minVR) * ((bodyW - minScreenSize) / (maxScreenSize - minScreenSize)))>>0
    document.documentElement.style.setProperty('--vr', VR+'px' );


    let $VRSnaps = document.querySelectorAll('[data-vr-snap]')
    $VRSnaps.forEach(($el)=>{
        $el.style.removeProperty('height');
        clearTimeout($el.snapTimer)
        $el.snapTimer = setTimeout(()=>{
            requestAnimationFrame(()=>{
                let targetHeight = ( Math.round($el.clientHeight / VR) * VR )
                $el.style.height = (targetHeight)+'px'
            })
        },10)
    });

    window.objectFitPolyfill && window.objectFitPolyfill()
    window.cssVarPoly && window.cssVarPoly();

}
window.addEventListener('resize', onResize)
window.addEventListener('orientationchange', onResize)
onResize()

// let isDebug = false
// function onkeypress(e) {
//     if (e.which==104) {
//         isDebug = !isDebug
//         document.body.classList[isDebug?'add':'remove']('is-debug')
//     }
// }
// window.addEventListener('keypress', onkeypress)